module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../~/symbol-observable/index.js
// module id = 459
// module chunks = 1